import { WaveConfig } from './types';

/**
 * Generates a wavy path with snake-like continuous animation
 */
export const generateWavyPath = (
  startX: number,
  startY: number,
  endX: number,
  endY: number,
  frame: number,
  phaseOffset: number,
  waveConfig: WaveConfig,
): string => {
  const points: string[] = [];

  for (let index = 0; index <= waveConfig.segments; index++) {
    const t = index / waveConfig.segments;

    // Linear interpolation along the line
    const baseX = startX + (endX - startX) * t;
    const baseY = startY + (endY - startY) * t;

    // Calculate perpendicular direction for wave offset
    const dx = endX - startX;
    const dy = endY - startY;
    const length = Math.sqrt(dx * dx + dy * dy);
    const perpX = -dy / length;
    const perpY = dx / length;

    // Snake-like wave calculation with time-based animation
    const waveTime = frame * waveConfig.speed + phaseOffset;
    const waveOffset =
      Math.sin(t * length * waveConfig.frequency + waveTime) *
      waveConfig.amplitude;

    const x = baseX + perpX * waveOffset;
    const y = baseY + perpY * waveOffset;

    if (index === 0) {
      points.push(`M ${x} ${y}`);
    } else {
      points.push(`L ${x} ${y}`);
    }
  }

  return points.join(' ');
};

/**
 * Calculates the approximate length of a wavy path
 */
export const calculatePathLength = (
  startX: number,
  startY: number,
  endX: number,
  endY: number,
): number => {
  // Base length plus some extra for waves
  const dx = endX - startX;
  const dy = endY - startY;
  const baseLength = Math.sqrt(dx * dx + dy * dy);
  // Add ~20% for wave curves
  return baseLength * 1.2;
};
